import { jsx, jsxs } from "react/jsx-runtime";
import {
  Box,
  Table as MuiTable,
  Paper,
  styled,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Tooltip
} from "@mui/material";
import { motion } from "../../../framer-motion/index.js";
import { Control } from "./Control.js";
import { DragIndicator } from "./icons/DragIndicator.js";
function FloatingControls(props) {
  const { setField, state, options } = props;
  const initialPosition = options?.floating ? options?.initialPosition : void 0;
  const tableSx = options?.tableSx;
  return /* @__PURE__ */ jsx(
    motion.div,
    {
      drag: true,
      dragMomentum: false,
      style: {
        left: initialPosition?.x ?? 0,
        maxWidth: 400,
        padding: 16,
        position: "fixed",
        top: initialPosition?.y ?? 0,
        zIndex: 1e3
      },
      children: /* @__PURE__ */ jsx(TableContainer, { component: Paper, children: /* @__PURE__ */ jsxs(Table, { size: "small", sx: tableSx, children: [
        /* @__PURE__ */ jsx(
          TableHead,
          {
            sx: {
              "&:hover": {
                background: "rgba(20,12,100,0.15)"
              },
              background: "rgba(20,12,100,0.05)",
              cursor: "grab",
              transition: "background 0.3s ease-out"
            },
            children: /* @__PURE__ */ jsxs(TableRow, { children: [
              /* @__PURE__ */ jsxs(TableCell, { sx: { position: "relative" }, children: [
                /* @__PURE__ */ jsx(
                  Box,
                  {
                    sx: {
                      alignItems: "center",
                      display: "flex",
                      height: "100%",
                      left: -1,
                      pointerEvents: "none",
                      position: "absolute",
                      top: 0,
                      width: 16
                    },
                    children: /* @__PURE__ */ jsx(DragIndicator, {})
                  }
                ),
                "Property"
              ] }),
              /* @__PURE__ */ jsxs(TableCell, { sx: { position: "relative" }, children: [
                "Value",
                /* @__PURE__ */ jsx(
                  Box,
                  {
                    sx: {
                      alignItems: "center",
                      display: "flex",
                      height: "100%",
                      pointerEvents: "none",
                      position: "absolute",
                      right: 0,
                      top: 0,
                      width: 16
                    },
                    children: /* @__PURE__ */ jsx(DragIndicator, {})
                  }
                )
              ] })
            ] })
          }
        ),
        /* @__PURE__ */ jsx(TableBody, { children: Object.entries(state).map(([fieldName, field]) => {
          const hidden = field.hidden?.(state) ?? false;
          return /* @__PURE__ */ jsxs(
            TableRow,
            {
              sx: {
                "&:last-child td, &:last-child th": { border: 0 },
                display: hidden ? "none" : void 0
              },
              children: [
                /* @__PURE__ */ jsx(TableCell, { children: /* @__PURE__ */ jsx(Tooltip, { arrow: true, placement: "top", title: field.description, children: /* @__PURE__ */ jsx("span", { children: field.label ?? fieldName }) }) }),
                /* @__PURE__ */ jsx(TableCell, { children: /* @__PURE__ */ jsx(Control, { field, id: fieldName, setField, state }) })
              ]
            },
            fieldName
          );
        }) })
      ] }) })
    }
  );
}
const Table = styled(MuiTable)(({ theme }) => ({
  userSelect: "none"
}));
export {
  FloatingControls
};
//# sourceMappingURL=FloatingControls.js.map
